module.exports = __webpack_public_path__ + "static/media/Farmer_Needs_for_GBR_Care_04-03-2024-removebg-preview.bccd14a9.png";